<script>
  import { fade, fly } from "svelte/transition";
  import { getLocal, persist } from "../../../stores/store";
  import { afterUpdate } from "svelte";
  import "./ArrayExtensions.js";
  import { activeTask } from "../../../stores/tasks.js";
  import Timer from "./Timer.svelte";

  let taskAddedPendingFocus = false;
  let lastInput;
  let pomodoroTodos = [];

  try {
    pomodoroTodos = getLocal("todos") || [];
  } catch (err) {
    pomodoroTodos = [];
  }

  function addTask() {
    taskAddedPendingFocus = true;
    let todo = {
      id: Math.random()
        .toString(36)
        .substr(2, 9),
      title: "new task",
      date: "No Date"
    };

    console.log(lastInput);

    let updTodos = [...pomodoroTodos, todo];
    localStorage.setItem("todos", JSON.stringify(updTodos));
    pomodoroTodos = updTodos;
  }

  function removeTask(task) {
    const idx = pomodoroTodos.findIndex(todo => todo.id === task.id);
    pomodoroTodos.splice(idx, 1);
    let updTodos = [...pomodoroTodos];
    localStorage.setItem("todos", JSON.stringify(updTodos));
    pomodoroTodos = updTodos;
    return pomodoroTodos;
    if ($activeTask === task) {
      selectTask(undefined);
    }
  }

  function focusNewTask() {
    if (taskAddedPendingFocus && lastInput) {
      lastInput.focus();
      taskAddedPendingFocus = false;
    }
  }

  function selectTask(task) {
    if ($activeTask === task) $activeTask = null;
    else $activeTask = task;
  }

  afterUpdate(focusNewTask);

  $: try {
    localStorage.setItem("todos", JSON.stringify(pomodoroTodos));
  } catch (err) {
    console.log(err);
  }
</script>

<style>
  .tasks {
    background-color: rgb(255, 255, 255, 0.8);
    color: #494d4e;
    padding: 2em;
    display: grid;
    justify-content: stretch;
    grid-gap: 1vh;
    border-radius: 5px;
    box-shadow: -5px 19px 38px rgba(0, 0, 0, 0.3),
      -5px 15px 12px rgba(0, 0, 0, 0.22);
  }

  ul {
    margin: 1vh 0;
    list-style-type: none;
    display: grid;
    grid-gap: 1vh;
    justify-content: stretch;
    width: 100%;
  }

  li {
    display: grid;
    grid-template-columns: 25px 1fr 40px;
    grid-gap: 10px;
    align-content: center;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  p {
    font-size: 2.2vh;
  }

  .select {
    align-self: center;
    width: 25px;
    height: 25px;
    padding: 2px;
    background-color: rgb(255, 255, 255);
  }

  .select:hover {
    filter: none;
    background-color: rgb(197, 197, 197);
    filter: invert(1) sepia(1) hue-rotate(150deg) saturate(1.5) brightness(1);
  }

  .remove {
    margin-left: -10px;
    padding: 5px 5px 0;
    border: none;
  }

  .remove:hover {
    border: none;
    filter: invert(0.2) sepia(1) hue-rotate(150deg) saturate(1.5) brightness(1);
  }

  input {
    margin: 0;
    border-radius: 5px;
    font-size: 1.8vh;
    font-weight: 600;
    letter-spacing: 0.2ch;
    width: 100%;
  }

  input:focus {
    outline: 2px solid #494d4e;
  }

  .active input {
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) inset;
    border: 1px ridge rgba(255, 255, 255, 0.25);
    background: linear-gradient(
        top,
        rgba(255, 255, 255, 0.7),
        transparent,
        rgba(255, 255, 255, 0.7)
      ),
      linear-gradient(left, rgb(28, 168, 187), rgb(2, 226, 255));
    background: -webkit-linear-gradient(
        top,
        rgba(255, 255, 255, 0.7),
        transparent,
        rgba(255, 255, 255, 0.7)
      ),
      -webkit-linear-gradient(left, rgb(28, 168, 187), rgb(2, 226, 255));
    color: white;
    border-radius: 5px;
    transition: all 0.1s linear;
  }

  img {
    cursor: pointer;
    width: 40px;
    height: 40px;
    transition: all 0.2s ease-in;
    border: 2px solid rgb(73, 77, 78);
    border-radius: 50%;
    justify-self: center;
  }

  img:hover {
    filter: invert(0.85) sepia(1) hue-rotate(150deg) saturate(1.5) brightness(1);
    border: 2px solid rgb(0, 0, 0);
    border-radius: 50%;
  }

  .bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
</style>

<div in:fade={{ duration: 700 }} class="tasks">
  {#if pomodoroTodos.length === 0}
    <p style="text-align: center;">
      You haven't added any tasks yet.
      <br />
      <span style="font-weight: bold; text-transform: uppercase;">
        You can do it!
      </span>
      <br />
      Add new tasks and start kicking some butt!
    </p>
  {:else}
    <ul>
      {#each pomodoroTodos as task}
        <li class:active={$activeTask === task}>
          <img
            class="select"
            on:click={() => selectTask(task)}
            src="./images/select.svg"
            alt="select task" />
          <input
            class="description"
            type="text"
            bind:value={task.title}
            bind:this={lastInput} />
          <img
            class="remove"
            on:click={() => removeTask(task)}
            src="./images/delete.svg"
            alt="remove todo" />
        </li>
      {/each}
    </ul>
  {/if}
  <div class="bottom">
    <img on:click={addTask} src="./images/circle-add.svg" alt="add task" />
  </div>
  {#if $activeTask}
    <Timer name={$activeTask.title} />
  {/if}
</div>
